// extracted by mini-css-extract-plugin
export default {"avatar":"userButton_avatar__pHU7x","userName":"userButton_userName__NCkbi"};